<template>
<div v-show="!chatId">
  <button class="ui orange button marunageButton" :class="buttonClass" @click="openDialog" :disabled="disabled">
    <slot></slot>
  </button>
  <div :id="dialogId" class="ui modal">
    <i class="close icon"></i>
    <div class="scrolling content">
        <detailed-marunage-form :action-label="'送信する'" ref="marunageForm" :form-name-prefix="formNamePrefix"></detailed-marunage-form>
    </div>
  </div>
</div>
</template>

<script>
import DetailedMarunageForm from './detailedMarunageForm.vue';

export default {
    components: {
        DetailedMarunageForm: DetailedMarunageForm
    },
    props: {
        shopId: {
            type: Number
        },
        bulk: {
            type: Boolean,
            default: false
        },
        area: {
            type: Number
        },
        areaDetail: {
            type: Number
        },
        courseId: {
            required: false,
            type: Number
        },
        buttonClass: {
            required: false,
            type: String,
            default: 'big fluid'
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
        formNamePrefix: {
            required: false,
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            chatId: this.query().chat_id
        };
    },
    mounted: function() {
        if (this.bulk) {
            this.$refs.marunageForm.bulk();
        }
        this.$refs.marunageForm.extendModel({
            shop_id: this.shopId,
            area: this.area,
            area_detail: this.areaDetail,
            course_id: this.courseId
        });
    },
    methods: {
        openDialog: function() {
            $('#' + this.dialogId).modal({closable: false, autofocus: false}).modal('show');
        }
    },
    computed: {
        dialogId: function() {
            if (this.courseId) {
                return 'marunage-dialog-' + this.courseId;
            } else if (this.bulk) {
                return 'bulk-marunage-dialog';
            } else {
                return 'marunage-dialog';
            }
        }
    }
};
</script>
